import useSWR from 'swr';
import { analyticsService, CustomersResponse } from '../services/analyticsService';

interface UseAnalyticsCustomersReturn {
  customers: CustomersResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

export const useAnalyticsCustomers = (year: number): UseAnalyticsCustomersReturn => {
  const { data, error, isLoading } = useSWR<CustomersResponse, Error>(
    `/api/v1/analytics/service/customers?year=${year}`,
    () => analyticsService.getCustomers(year),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  return {
    customers: data,
    loading: isLoading,
    error,
  };
};
